import { useContext } from "react";
import SentimentDrivers from "../SentimentDriver/SentimentDriver";
import MarketSummary from "./MarketSummary";
import { DiscoveryContext } from "../discovery-context";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import classes from "./MarketOverview.module.css";
import { LLM_OPTIONS } from "../../../utils/constant";
import { filterKey } from "../BrandAudit";

export default function BrandOverview() {
  const discoveryCtx = useContext(DiscoveryContext);
  console.log("discoveryCtx", discoveryCtx);
  return (
    <>
      <div className={classes.containerWrapper}>
        <MarketSummary />
        <div className={classes.headerWrapper}>
          <h5 className={classes.heading}>Sentiment Drivers</h5>
          <div className={classes.dropdownWrapper}>
            <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectedLLM}
              label={"LLM"}
              options={(discoveryCtx.llm || []).map((llm) => {
                const match = LLM_OPTIONS.find((option) => option.value === llm);
                return {
                  name: match ? match.name : llm,
                  value: llm,
                };
              })}
              onChange={(e) => {
                discoveryCtx.updateSelectedLLM(e.target.value);
              }}
            />
            <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectdMarket}
              label={"Market"}
              options={(discoveryCtx?.markets || []).map((market) => {
                return {
                  name: market,
                  value: market,
                };
              })}
              onChange={(e) => {
                discoveryCtx.updateSelectedMarket(e.target.value);
              }}
            />
          </div>
        </div>
        <SentimentDrivers
          isSelectedMarket={true}
        />
      </div>
    </>
  );
}
